import { IHocSinhLichSuYTeSuDungThuocRequest } from "../models/request/hoc-sinh/IHocSinhLichSuYTeSuDungThuocRequest";
import { apiGuestClient } from "./apiGuestClient";

export const HOC_SINH_LICH_SU_Y_TE_SU_DUNG_THUOC_API_END_POINT = "hoc-sinh-lich-su-y-te-su-dung-thuoc";

export const hocSinhLichSuYTeSuDungThuocApi = {
    // Lấy danh sách sử dụng thuốc theo lịch sử y tế ID
    selectByLichSuYTeId: (lichSuYTeId: number) => 
        apiGuestClient.get(`${HOC_SINH_LICH_SU_Y_TE_SU_DUNG_THUOC_API_END_POINT}/lich-su-y-te/${lichSuYTeId}`),

    // Thêm mới sử dụng thuốc
    insert: (data: IHocSinhLichSuYTeSuDungThuocRequest) => 
        apiGuestClient.post(`${HOC_SINH_LICH_SU_Y_TE_SU_DUNG_THUOC_API_END_POINT}`, data),

    // Cập nhật sử dụng thuốc
    update: (id: number, data: IHocSinhLichSuYTeSuDungThuocRequest) => 
        apiGuestClient.put(`${HOC_SINH_LICH_SU_Y_TE_SU_DUNG_THUOC_API_END_POINT}/${id}`, data),

    // Xóa sử dụng thuốc
    delete: (id: number) => 
        apiGuestClient.delete(`${HOC_SINH_LICH_SU_Y_TE_SU_DUNG_THUOC_API_END_POINT}/${id}`),
};
